export const ratingNumberRange = [1, 2, 3, 4, 5];
